import * as React from 'react';
import * as styles from './styles.css';

import { RadioButton, Input, Button, InputAdornment } from '@cian/ui-kit';

import { RATES } from '../../../constants/rateOurEstimation';
import { ERateValues } from '../../../types/redux/rateOurEstimation';

export interface IRateOurEstimationFormProps {
  isDesktop: boolean;
  isLoading?: boolean;
  priceValue: string;
  comment?: string;
  rateOurEstimationValue?: ERateValues;
  rateOnChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onChangeUserPrice(e: React.ChangeEvent<HTMLInputElement>): void;
  onChangeComment(e: React.ChangeEvent<HTMLTextAreaElement>): void;
  onClose(): void;
  onSubmit(): void;
}

export const RateOurEstimationForm: React.FC<IRateOurEstimationFormProps> = ({
  isDesktop,
  isLoading,
  priceValue,
  rateOurEstimationValue,
  comment,
  onChangeUserPrice,
  onChangeComment,
  rateOnChange,
  onClose,
  onSubmit,
}) => {
  return (
    <>
      <div data-testid="RateOurEstimationForm" className={styles['rates']}>
        {RATES.map(item => {
          return (
            <div key={item.value} className={styles['rate-item']}>
              <RadioButton
                name="rateOurEstimationVariant"
                label={item.label}
                value={item.value}
                onChange={rateOnChange}
              />
            </div>
          );
        })}
      </div>
      <div data-testid="input_price_value" className={styles['input']}>
        <Input
          placeholder="Укажите справедливую цену"
          rightAdornment={<InputAdornment>₽</InputAdornment>}
          value={priceValue}
          onChange={onChangeUserPrice}
        />
      </div>
      <textarea
        placeholder="Что мы не учли в оценке?"
        rows={4}
        className={styles['textarea']}
        value={comment}
        onChange={onChangeComment}
      ></textarea>
      <div data-testid="btn_onClose" className={styles['footer']}>
        <Button
          theme={isDesktop ? 'fill_white_primary' : 'fill_secondary'}
          size={isDesktop ? 'XS' : 'M'}
          onClick={onClose}
        >
          Отмена
        </Button>
        <Button
          theme={isDesktop ? 'fill_secondary' : 'fill_primary'}
          size={isDesktop ? 'XS' : 'M'}
          onClick={onSubmit}
          loading={isLoading}
          disabled={!rateOurEstimationValue}
        >
          Отправить
        </Button>
      </div>
    </>
  );
};

RateOurEstimationForm.displayName = 'RateOurEstimationForm';
